import React, { useContext } from 'react';
import cn from 'classnames';
import { ReactComponent as CheckIcon } from './icons/checkIcon.svg';

import styles from './Resume.module.css';
import LanguageContext from '../context/LanguageContext';

export default function ItemList({ itemList }) {
    const { language } = useContext(LanguageContext);

    const sortedItemList = itemList.sort((a, b) => {
        const parseDate = (dateStr) => {
            if (!dateStr) return null;

            const [month, year] = dateStr.split('/').map(Number);
            return new Date(year, month - 1, 1);
        };

        const dateA = parseDate(a.startDate);
        const dateB = parseDate(b.startDate);

        if (!dateA) return -1;
        if (!dateB) return 1;

        return dateB - dateA;
    });

    return sortedItemList.map((item) => (
        <div className={cn(styles.resumeItem)} key={item.duties}>
            <div
                className={cn(styles.date, {
                    [styles.it]: item.area === 'it',
                })}
            >
                {item.startDate} -{' '}
                {item.endDate ? (
                    item.endDate
                ) : (
                    <span
                        className={cn({
                            [styles.present]: !item.endDate,
                        })}
                    >
                        {language === 'en' ? 'Now' : 'Досі'}
                    </span>
                )}
            </div>
            <div className={cn(styles.position)}>
                {language === 'en' ? item.position : item.positionUA}
            </div>
            <div className={cn(styles.company)}>
                {item.company
                    ? language === 'en'
                        ? item.company
                        : item.companyUA
                    : language === 'en'
                    ? 'Freelance'
                    : 'Фріланс'}{' '}
                | {language === 'en' ? item.place : item.placeUA}
            </div>
            <ul>
                {language === 'en'
                    ? item.duties.map((el, i) => (
                          <li className={styles.duty} key={i}>
                              {el}
                          </li>
                      ))
                    : item.dutiesUA.map((el, i) => (
                          <li className={styles.duty} key={i}>
                              {el}
                          </li>
                      ))}
            </ul>
            {item.notes && (
                <small>{language === 'en' ? item.notes : item.notesUA}</small>
            )}
            {item.usedTechnics.length > 0 && (
                <span>
                    {language === 'en'
                        ? item.type === 'education'
                            ? 'Acquired skills:'
                            : 'Used skills:'
                        : item.type === 'education'
                        ? 'Набуті навички:'
                        : 'Застосовані навички:'}
                </span>
            )}
            <ul>
                {(language === 'en'
                    ? item.usedTechnics && item.usedTechnics
                    : item.usedTechnicsUA
                    ? item.usedTechnicsUA
                    : item.usedTechnics
                ).map((tech) => (
                    <li key={tech}>
                        <div>
                            <CheckIcon className={cn(styles.checkIcon)} />
                        </div>

                        {tech}
                    </li>
                ))}
            </ul>
        </div>
    ));
}
